import Vue from 'vue';
import dialogPlugin from 'BASE/plugins/toastDialogPlugin';
import dialogComponent from 'XY/views/Dialog.vue';
import SpeedTest from 'XY/views/SpeedTest/SpeedTest.vue';
import store from 'XY/store/store';
import datadogRumPlugin from 'BASE/plugins/datadogRumPlugin';
import ToastDialog from 'XY/views/ToastDialog.vue';

Vue.use(dialogPlugin, { dialogComponent: dialogComponent, ToastDialog: ToastDialog });
Vue.use(datadogRumPlugin, { isMobile: false });

new Vue({
    render: h => h(SpeedTest),
    store,
}).$mount('#app');
